import "../styles/application.css"

import { createInertiaApp } from "@inertiajs/react"
import { createRoot } from "react-dom/client"

import { AppLayout } from "../components/layout/AppLayout"

if (document.getElementById("app")) {
  createInertiaApp({
    resolve: (name) => {
      const pages = import.meta.glob("../pages/**/*.tsx", { eager: true })
      return pages[`../pages/${name}.tsx`]
    },
    setup({ el, App, props }) {
      createRoot(el).render(
        <AppLayout>
          <App {...props} />
        </AppLayout>
      )
    }
  })
}
